import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { BrandListResponse } from './brand.model';
@Injectable({
  providedIn: 'root'
})

export class BrandService {

  private brandListSubject: BehaviorSubject<BrandListResponse>;

  constructor(private http: HttpClient,
    @Inject('API_URL') private apiUrl: string
  ) {
    this.brandListSubject = new BehaviorSubject<BrandListResponse>(null);
  }

  getBrandList() {
    return new Promise<void>((resolve, reject) => {
      this.http.get<BrandListResponse>(this.apiUrl + 'brand/brand-list')
        .subscribe({
          next: (response) => {
            this.brandListSubject.next(response);
            resolve();
          },
          error: (err) => reject(err)
        });
    });
  }
  
  getBrandListWithFilter(filter: any): Observable<BrandListResponse> {
    let params = new HttpParams();
  
    if (filter) {
      params = params.set('filter', JSON.stringify(filter));
    }
    
    return this.http.get<BrandListResponse>(
      this.apiUrl + 'brand/brand-list',
      { params }
    );
  }

  public getLogo(logo: string): string{
    return 'data:image/png;base64,' + logo;
  }

  public getLogoById(id: number): string{
    var logo = this.brandListSubject.value.model.find(brand => brand.id == id)?.logo;
    return 'data:image/png;base64,' + logo;
  }

  public get brandList(): BrandListResponse {
    return this.brandListSubject.value;
  }
}
